import { callApi } from 'modules/core/api/services'

export const highlightByUuid = (highlightUuid: string) =>
  callApi(`/v2/media_assets/${highlightUuid}`)
